<div class="container">
    <div class="modal-header">
        <h1 class="modal-title row">Receipt Attachment</h1>
    </div>
    <div>
        <table class="table table-responsive-lg">
            <thead>
                <tr>
                    <th><h5>Employee</h5></th>
                    <th><h5>Name</h5></th>
                    <th><h5>Date</h5></th>
                    <th><h5>Package</h5></th>
                    <th><h5>Receipt Description</h5></th>
                    <th><h5>Amt</h5></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr class="clickableRow" style="cursor:pointer;">
                    <td>{{receiptDetails.Employee}}</td>
                    <td>{{receiptDetails.ExpenseEmployeeName}}</td>
                    <td>{{receiptDetails.ExpenseDateDisplay}}</td>
                    <td>{{receiptDetails.HeaderDescription}}</td>
                    <td>{{receiptDetails.ReceiptDescription}}</td>
                    <td>
                        <span *ngIf="receiptDetails.ReceiptAmount != null">{{receiptDetails.ReceiptAmount | currency : currencySymbol}}</span>
                        <span *ngIf="receiptDetails.ReceiptAmount == null">{{0 | currency : currencySymbol}}</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="6">
                        <div class="card">
                            <div class="card-body">
                                <table class="table" style="margin-bottom: 0px;">
                                    <thead>
                                        <tr>
                                            <th style="min-width: 450px;">Charge To</th>
                                            <th style="min-width: 60px;">Item Amount</th>
                                            <th style="min-width: 60px;">Status</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let lineItem of receiptItemsDetails">
                                            <td>
                                                <span *ngIf="lineItem.IsLineCoded">{{lineItem.ChargeToLabel}}</span>
                                                <i *ngIf="!lineItem.IsLineCoded" style="color:red;" class="modus-icons" aria-hidden="true">warning</i>
                                            </td>
                                            <td>
                                                <span *ngIf="lineItem.ItemAmount != null">{{lineItem.ItemAmount | currency : currencySymbol}}</span>
                                                <span *ngIf="lineItem.ItemAmount == null">{{0 | currency : currencySymbol}}</span>
                                            </td>
                                            <td>{{lineItem.ItemStatusLabel}}</td>
                                            <td style="width: 230px;" *ngIf="!mobileMode">
                                                <span *ngIf="lineItem.HasItemAttachment"
                                                      style="color:blue; width:15px;"
                                                      class="mt-2 oi oi-paperclip">
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div>
        <div class="col-lg-3 col-md-5">
            <ng-select [(ngModel)]="selectedAttachment" 
                       [searchable]="false"
                       [clearable]="false">
                <ng-option *ngFor="let data of receiptAttachments" [value]="data">
                    {{data.AttachmentCaption == null || data.AttachmentCaption === '' ? data.AttachmentFileName : data.AttachmentCaption}}
                </ng-option>
            </ng-select>
        </div>
    </div>
    <div>
        <app-read-only-pdf-viewer [attachment]="selectedAttachment" (alertCreated)="alert = $event"></app-read-only-pdf-viewer>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="close()">Close</button>
    </div>
</div>